// p20 (9-oct-2026) · "Enviar a" de las fotos del catálogo, como el de WhatsApp:
// buscador arriba, y los clientes clasificados igual que WhatsApp: Frecuentes (a quienes más les
// escribes), Chats recientes, Grupos y Otros clientes. Círculo para elegir a la derecha, y abajo la
// miniatura de lo que mandas, "Añade un mensaje…" y el botón verde de enviar con los nombres elegidos.
// Solo es la pantalla: quién recibe y cómo se manda lo sigue haciendo confirmSend (App-merged.jsx).
import React from 'react';
const { useMemo } = React;

const DIA = 86400000;
const PALETA = [['#FCE4EC', '#C2185B'], ['#E3F2FD', '#1E6FB5'], ['#E6F4EA', '#1D8A4E'], ['#FFF3E0', '#B26A00'], ['#EDE7F6', '#6A3FB5'], ['#E0F2F1', '#00796B']];
const sinAcento = s => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
const digitos = s => String(s || '').replace(/\D/g, '');
const tieneTel = c => digitos(c && c.phone).length >= 10;
const telBonito = p => { const d = digitos(p).slice(-10); return d.length === 10 ? d.slice(0, 2) + ' ' + d.slice(2, 6) + ' ' + d.slice(6) : ''; };
const colorDe = id => { const n = Math.abs(parseInt(String(id).replace(/\D/g, '').slice(-6) || '0', 10)); return PALETA[n % PALETA.length]; };
const ultReal = c => (c && c.ult && !c.ult.camp && c.ult.at) ? c.ult.at : 0;

const ICO = {
  x: <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /></svg>,
  lupa: <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5" fill="none" stroke="currentColor" strokeWidth="2" /><path d="M15.5 15.5L21 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /></svg>,
  persona: <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8" r="4.2" fill="currentColor" /><path d="M3.5 21c.8-4.4 4.3-7 8.5-7s7.7 2.6 8.5 7z" fill="currentColor" /></svg>,
  grupo: <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true"><circle cx="8.5" cy="8.5" r="3.4" fill="currentColor" /><circle cx="16.3" cy="9.2" r="2.8" fill="currentColor" /><path d="M1.8 19.5c.6-3.6 3.4-5.6 6.7-5.6s6.1 2 6.7 5.6z" fill="currentColor" /><path d="M15.8 13.6c2.9-.2 5.5 1.5 6.2 4.9h-5.2c-.2-1.9-.6-3.5-1-4.9z" fill="currentColor" /></svg>,
  palomita: <svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path d="M2.5 7.3l3 3 6-6.3" fill="none" stroke="#FFFFFF" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" /></svg>,
  enviar: <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true"><path d="M3.4 20.4l17.4-7.5c.8-.4.8-1.5 0-1.8L3.4 3.6c-.7-.3-1.4.3-1.2 1l1.9 6.4 8.4 1-8.4 1-1.9 6.4c-.2.7.5 1.3 1.2 1z" fill="currentColor" /></svg>,
};

const CSS = `
.wf{position:fixed;inset:0;margin:0 auto;max-width:560px;background:#F2F2F7;z-index:320;display:flex;flex-direction:column;font-family:-apple-system,BlinkMacSystemFont,"SF Pro Text","Helvetica Neue",Helvetica,Arial,sans-serif;color:#000;-webkit-font-smoothing:antialiased}
.wf *{box-sizing:border-box}
.wf-top{display:flex;align-items:center;gap:12px;padding:calc(12px + env(safe-area-inset-top,0px)) 16px 8px;flex-shrink:0}
.wf-x{width:36px;height:36px;border-radius:50%;border:none;background:#E3E3E8;color:#000;display:flex;align-items:center;justify-content:center;padding:0;cursor:pointer;flex-shrink:0}
.wf-t{font-size:17px;font-weight:600;flex:1;min-width:0}
.wf-t small{display:block;font-size:12.5px;font-weight:400;color:#8E8E93;margin-top:1px}
.wf-bus{margin:4px 16px 6px;height:38px;border-radius:12px;background:#E3E3E8;display:flex;align-items:center;gap:8px;padding:0 10px;color:#8E8E93;flex-shrink:0}
.wf-bus input{flex:1;min-width:0;border:none;background:transparent;font-size:17px;color:#000;outline:none;font-family:inherit;padding:0}
.wf-bus input::placeholder{color:#8E8E93}
.wf-bus .wf-limpia{border:none;background:#AEAEB2;color:#FFFFFF;width:18px;height:18px;border-radius:50%;display:flex;align-items:center;justify-content:center;padding:0;cursor:pointer}
.wf-bus .wf-limpia svg{width:8px;height:8px}
.wf-body{flex:1;overflow-y:auto;-webkit-overflow-scrolling:touch;padding:2px 0 16px}
.wf-sec{font-size:15px;font-weight:600;color:#8E8E93;padding:18px 20px 7px}
.wf-card{background:#FFFFFF;border-radius:14px;margin:0 16px;overflow:hidden}
.wf-row{display:flex;align-items:center;gap:12px;width:100%;border:none;background:transparent;padding:0 0 0 14px;text-align:left;cursor:pointer;font-family:inherit;color:inherit;min-height:62px;content-visibility:auto;contain-intrinsic-size:auto 62px}
.wf-row:active{background:#E5E5EA}
.wf-row[disabled]{cursor:default}
.wf-row[disabled] .wf-av,.wf-row[disabled] .wf-n{opacity:.45}
.wf-av{width:44px;height:44px;border-radius:50%;display:flex;align-items:center;justify-content:center;flex-shrink:0}
.wf-tx{flex:1;min-width:0;display:flex;align-items:center;gap:10px;align-self:stretch;padding:9px 16px 9px 0;border-bottom:.5px solid #D1D1D6}
.wf-row:last-child .wf-tx{border-bottom:none}
.wf-nm{flex:1;min-width:0}
.wf-n{display:block;font-size:17px;line-height:1.25;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.wf-s{display:block;font-size:14px;line-height:1.3;color:#8E8E93;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:1px}
.wf-s.no{color:#FF3B30}
.wf-ck{width:24px;height:24px;border-radius:50%;border:1.5px solid #C7C7CC;flex-shrink:0;display:flex;align-items:center;justify-content:center}
.wf-row.on .wf-ck{background:#25D366;border-color:#25D366}
.wf-vacio{padding:28px 24px;text-align:center;color:#8E8E93;font-size:15px}
.wf-pie{flex-shrink:0;background:#F2F2F7;border-top:.5px solid #D1D1D6;padding:10px 16px calc(10px + env(safe-area-inset-bottom,0px))}
.wf-msg{display:flex;align-items:flex-end;gap:10px}
.wf-mini{position:relative;width:52px;height:52px;border-radius:8px;overflow:hidden;background:#E3E3E8;flex-shrink:0}
.wf-mini img{width:100%;height:100%;object-fit:cover;display:block}
.wf-mini b{position:absolute;right:3px;bottom:3px;min-width:20px;height:20px;border-radius:10px;background:rgba(0,0,0,.6);color:#FFFFFF;font-size:12px;font-weight:600;display:flex;align-items:center;justify-content:center;padding:0 5px}
.wf-msg textarea{flex:1;min-width:0;min-height:52px;max-height:110px;border:.5px solid #D1D1D6;border-radius:18px;background:#FFFFFF;font-size:17px;line-height:1.3;padding:14px 14px;resize:none;font-family:inherit;color:#000;outline:none}
.wf-msg textarea::placeholder{color:#8E8E93}
.wf-van{display:flex;align-items:center;gap:12px;margin-top:10px}
.wf-van span{flex:1;min-width:0;font-size:15px;color:#000;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.wf-van span small{display:block;font-size:12.5px;color:#8E8E93}
.wf-go{width:50px;height:50px;border-radius:50%;border:none;background:#25D366;color:#FFFFFF;display:flex;align-items:center;justify-content:center;padding:0 0 0 3px;cursor:pointer;flex-shrink:0}
.wf-go[disabled]{background:#A5E5BD}
`;

function Fila({ k, nombre, sub, subNo, grupo, on, off, onClick, colorId }) {
  const [bg, fg] = grupo ? ['#DCF8E8', '#0B8F48'] : colorDe(colorId);
  return (
    <button type="button" className={'wf-row' + (on ? ' on' : '')} disabled={off} onClick={onClick} aria-pressed={!!on} data-k={k}>
      <span className="wf-av" style={{ background: bg, color: fg }}>{grupo ? ICO.grupo : ICO.persona}</span>
      <span className="wf-tx">
        <span className="wf-nm"><span className="wf-n">{nombre}</span>{sub ? <span className={'wf-s' + (subNo ? ' no' : '')}>{sub}</span> : null}</span>
        <span className="wf-ck">{on ? ICO.palomita : null}</span>
      </span>
    </button>
  );
}

export default function EnviarAWA(props) {
  const { clients = [], groups = [], freq = [], loading, cart = [], selC = {}, setSelC, selG = {}, setSelG,
    search = '', setSearch, msg = '', setMsg, sending, prog, onClose, onSend } = props;
  const q = sinAcento(search.trim());

  const secciones = useMemo(() => {
    const porId = {};
    clients.forEach(c => { porId[c.id] = c; });
    const usados = new Set();
    const frecuentes = [];
    (freq || []).forEach(f => { const c = porId[f.id]; if (c && tieneTel(c) && !usados.has(c.id) && frecuentes.length < 5) { frecuentes.push(c); usados.add(c.id); } });
    const desde = Date.now() - 30 * DIA;
    const recientes = clients.filter(c => !usados.has(c.id) && tieneTel(c) && ultReal(c) > desde)
      .sort((a, b) => ultReal(b) - ultReal(a)).slice(0, 15);
    recientes.forEach(c => usados.add(c.id));
    const otros = clients.filter(c => !usados.has(c.id))
      .sort((a, b) => (tieneTel(b) - tieneTel(a)) || String(a.name || '').localeCompare(String(b.name || ''), 'es', { sensitivity: 'base' }));
    return { frecuentes, recientes, otros };
  }, [clients, freq]);

  const encontrados = useMemo(() => {
    if (!q) return null;
    const qd = digitos(q);
    const pasa = c => sinAcento(c.name).includes(q) || (qd.length >= 3 && digitos(c.phone).includes(qd));
    return {
      grupos: groups.filter(g => sinAcento(g.name).includes(q)),
      clientes: clients.filter(pasa).sort((a, b) => (tieneTel(b) - tieneTel(a)) || String(a.name || '').localeCompare(String(b.name || ''), 'es', { sensitivity: 'base' })).slice(0, 200),
    };
  }, [q, clients, groups]);

  const elegidos = [
    ...groups.filter(g => selG[g.id]).map(g => g.name),
    ...clients.filter(c => selC[c.id]).map(c => c.name),
  ];
  const nSel = elegidos.length;
  const tocaC = c => { if (!tieneTel(c) || sending) return; setSelC(p => ({ ...p, [c.id]: !p[c.id] })); };
  const tocaG = g => { if (sending) return; setSelG(p => ({ ...p, [g.id]: !p[g.id] })); };
  const filaC = (c, sec) => (
    <Fila key={sec + c.id} k={'c' + c.id} nombre={c.name || 'Sin nombre'} colorId={c.id}
      sub={tieneTel(c) ? telBonito(c.phone) : 'Sin teléfono'} subNo={!tieneTel(c)}
      on={!!selC[c.id]} off={!tieneTel(c)} onClick={() => tocaC(c)} />
  );
  const filaG = g => (
    <Fila key={'g' + g.id} k={'g' + g.id} grupo nombre={g.name} sub={(g.total || 0) + ' cliente' + ((g.total || 0) === 1 ? '' : 's')}
      on={!!selG[g.id]} off={!(g.total > 0)} onClick={() => tocaG(g)} />
  );
  const seccion = (titulo, filas) => filas.length ? (
    <React.Fragment key={titulo}>
      <div className="wf-sec">{titulo}</div>
      <div className="wf-card">{filas}</div>
    </React.Fragment>
  ) : null;

  const primera = cart[0];
  const nFotos = cart.length;

  return (
    <div className="wf" role="dialog" aria-modal="true" aria-label="Enviar a">
      <style>{CSS}</style>
      <div className="wf-top">
        <button type="button" className="wf-x" aria-label="Cerrar" onClick={onClose}>{ICO.x}</button>
        <div className="wf-t">Enviar a<small>{nFotos} foto{nFotos === 1 ? '' : 's'}</small></div>
      </div>
      <label className="wf-bus">
        {ICO.lupa}
        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Buscar" aria-label="Buscar cliente o grupo" enterKeyHint="search" />
        {search ? <button type="button" className="wf-limpia" aria-label="Borrar búsqueda" onClick={() => setSearch('')}>{ICO.x}</button> : null}
      </label>
      <div className="wf-body">
        {loading && <div className="wf-vacio">Cargando…</div>}
        {!loading && encontrados && (
          (encontrados.grupos.length || encontrados.clientes.length) ? [
            seccion('Grupos', encontrados.grupos.map(filaG)),
            seccion('Clientes', encontrados.clientes.map(c => filaC(c, 'b'))),
          ] : <div className="wf-vacio">Sin resultados para «{search.trim()}»</div>
        )}
        {!loading && !encontrados && [
          seccion('Frecuentes', secciones.frecuentes.map(c => filaC(c, 'f'))),
          seccion('Chats recientes', secciones.recientes.map(c => filaC(c, 'r'))),
          seccion('Grupos', groups.map(filaG)),
          seccion('Otros clientes', secciones.otros.map(c => filaC(c, 'o'))),
        ]}
        {!loading && !clients.length && !groups.length && <div className="wf-vacio">No hay clientes en tu cartera. Si no ves clientes, pídele al administrador el permiso de "Mis Clientes".</div>}
      </div>
      <div className="wf-pie">
        <div className="wf-msg">
          {primera ? <span className="wf-mini"><img src={'/api/products/' + primera.pid + '/gallery/' + primera.idx + '/thumb'} alt="" />{nFotos > 1 ? <b>{nFotos}</b> : null}</span> : null}
          <textarea rows={1} value={msg} onChange={e => setMsg(e.target.value)} placeholder="Añade un mensaje…" aria-label="Añade un mensaje" />
        </div>
        {(nSel > 0 || sending) && (
          <div className="wf-van">
            <span>{sending ? (prog || 'Enviando…') : elegidos.join(', ')}{!sending && <small>{nSel} destinatario{nSel === 1 ? '' : 's'}</small>}</span>
            <button type="button" className="wf-go" aria-label={'Enviar a ' + nSel} disabled={sending || nSel === 0} onClick={onSend}>{ICO.enviar}</button>
          </div>
        )}
      </div>
    </div>
  );
}
